import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { AddOutlined, DeleteOutlined, KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import React, { useRef, useState } from "react"

import { Button } from "@/components/common/Button"

interface BulkActionsProps {
  isDeleteDisabled?: boolean
  onClickBulkDelete: () => void
  onClickBulkCreate: () => void
}

const BulkActions: FC<BulkActionsProps> = ({ isDeleteDisabled, onClickBulkDelete, onClickBulkCreate }) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false)
  const anchorElRef = useRef<HTMLButtonElement>(null)

  const withClose = (action: () => void) => () => {
    action()
    setMenuOpen(false)
  }

  return (
    <Box className='mb-4'>
      <Button
        appearance='outlined'
        disabled={isDeleteDisabled}
        endIcon={<KeyboardArrowDownOutlined />}
        onClick={() => setMenuOpen(!menuOpen)}
        ref={anchorElRef}
      >
        Bulk Actions
      </Button>

      <Menu
        anchorEl={anchorElRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={withClose(onClickBulkDelete)}>
          <ListItemIcon>
            <DeleteOutlined className='text-gray-600' />
          </ListItemIcon>
          <ListItemText primary='Delete Certificates' className='text-gray-800' />
        </MenuItem>
        <Divider />
        <MenuItem onClick={withClose(onClickBulkCreate)}>
          <ListItemIcon>
            <AddOutlined className='text-gray-600' />
          </ListItemIcon>
          <ListItemText primary='Add Certificates' className='text-gray-800' />
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default BulkActions
